"use strict";
const signalRServices_1 = require("../../common/src/signalR/signalRServices");
const script_1 = require("./script");
exports.SCRIPT_HUBSERVICEPROVIDER_ENTRY = { provide: signalRServices_1.IHUBSERVICE_TOKEN, useClass: script_1.InaxScriptService, multi: true };
